//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ElLottie from '@/components/UI/el-lottie'

export default {
  name: 'ResultSection',
  components: {
    ElLottie,
  },
  data() {
    return {
      resultAnimation: {
        container: '.result__rocket',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path
          .split('/')
          .pop()}/result-rocket.json`,
      },
    }
  },
}
